import { type SettingsTemplate, settingsTemplate } from './template'

export const ENV_KEY = 'dev'

export const dev: SettingsTemplate = {
  ...settingsTemplate,

  DEPLOY_STORYBOOK: true,

  ENABLE_METRICS: true,

  // Internal tool - no origin restriction (real protection comes from auth, not CORS)
  API_CORS_ALLOW_ORIGIN: '*',

  COMFYUI_AUTO_SHUTDOWN_IDLE_HOURS: 3,
  COMFYUI_USE_SPOT_INSTANCE: false,
  COMFYUI_SPOT_MAX_PRICE: '',
  DEPLOY_COMFYUI_EC2: false,

  // dev.gmi-character-playground.exp.monks.zone (zone delegation is already live)
  ENABLE_CUSTOM_DOMAIN: true
}
